import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Grid } from 'semantic-ui-react'
// import moment from 'moment';
// import _ from 'lodash';
// import uuidv1 from 'uuid/v1';

import FormsInputsText from '../../../inputs/text/forms_inputs_text';
// import FormsInputDate from '../../inputs/date';
import FormsInputDropdown from '../../../inputs/dropdown';
// import FormsInputsTextNormal from '../../inputs/text_normal';
// import FormsInputsDropdownAddition from '../../inputs/dropdownaddition';

class FormsHradminEmployeeSearchBarForm extends Component {
    render() {
        const searchTypeOptions = [
            { text: 'Staff ID', value: 'staffId' },
            { text: 'Name', value: 'name' },
            // { text: 'NRIC', value: 2 },
        ];
        return (
            <Formik
                initialValues={{ 
                    searchType: 'name',
                    searchText: ''
                }}
                onSubmit={(values, actions) => {
                    // console.log(values, actions);
                    this.props.updateSearchParameters(values.searchType, values.searchText);
                    actions.setSubmitting(false);
                }}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width={4}>
                                    <Field
                                        name="searchType" 
                                        options={searchTypeOptions} 
                                        label="Search Type" 
                                        secondaryLabel=""
                                        component={FormsInputDropdown}
                                    />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Field name="searchText" label="Search For Value" component={FormsInputsText} secondaryLabel=""/>
                                </Grid.Column>
                                <Grid.Column width={4} verticalAlign="bottom">
                                    <Button 
                                        type="submit" 
                                        secondary 
                                        disabled={isSubmitting} 
                                        fluid 
                                        loading={isSubmitting}
                                    >
                                        Search Employee
                                    </Button>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Form>
                )}
            />
        );
    }
}

export default FormsHradminEmployeeSearchBarForm;